/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A yes to the sent price. The contact fields are for a home with no contact on file (an
 * OFFER-mode sale whose first outreach was the price): then name, email and `consent_accepted`
 * true are required (422 otherwise; on a decline only once an email or phone is given, TXN-3475).
 * With a contact on file they are ignored. As for interest, the consent text itself is not sent:
 * the server stores its own copy (`CONSENT_CHECKBOX_TEXT`).
 * @export
 * @interface HomeownershipTermsAcceptRequest
 */
export interface HomeownershipTermsAcceptRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsAcceptRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsAcceptRequest
     */
    termsId: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsAcceptRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsAcceptRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsAcceptRequest
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipTermsAcceptRequest
     */
    consentAccepted?: boolean;
}

/**
 * Check if a given object implements the HomeownershipTermsAcceptRequest interface.
 */
export function instanceOfHomeownershipTermsAcceptRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "termsId" in value;

    return isInstance;
}

export function HomeownershipTermsAcceptRequestFromJSON(json: any): HomeownershipTermsAcceptRequest {
    return HomeownershipTermsAcceptRequestFromJSONTyped(json, false);
}

export function HomeownershipTermsAcceptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipTermsAcceptRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'termsId': json['terms_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'consentAccepted': !exists(json, 'consent_accepted') ? undefined : json['consent_accepted'],
    };
}

export function HomeownershipTermsAcceptRequestToJSON(value?: HomeownershipTermsAcceptRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'terms_id': value.termsId,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'consent_accepted': value.consentAccepted,
    };
}

